<template>
  <div
    class="topNav"
    :class="{ 'env-zh': isZH }"
  >
    <div
      class="topNav-logo111"
      :style="{ width: curWidth + 40 + 'px' }"
    >
      <img
        v-if="isZH"
        :src="'https://admin.freelynet-tower.com:7443/bucket-test/8b601324020149b5b18958430967e006.jpg'"
      />
      <img
        v-else
        :src="mLogoUrl"
      />
      <!-- <div
        v-show="ents.length == 1"
        class="ent-name-info"
      >
        <span>{{ enterPriseName && enterPriseName.length > 8 ? enterPriseName.slice(0,7) + '...' :  enterPriseName}}</span>
      </div> -->
      <!-- <enterprise-select
        :showVisible='showVisible'
        @changeEntInfo="changeEntInfo"
        @closeEntSelect="closeEntSelect"
        v-show="false"
      ></enterprise-select> -->
    </div>
    <div class="topNav-list">
      <a-menu
        class="list-menu"
        mode="horizontal"
        v-model="currentNav"
        @click="handleClick"
      >
        <!-- <a-menu-item class="list-item" key="home">
          首页
        </a-menu-item> -->
        <a-menu-item
          class="list-item"
          :style="{ marginRight: menu.length > 8 ? '3.17vw' : '4.17vw' }"
          v-for="item in realMenu"
          :key="item.code"
        >
          {{ item.name }}
        </a-menu-item>
      </a-menu>
      <!-- 超过8个一级菜单下拉框展示start -->
      <div
        class="menu-select"
        v-if="selectMenu.length"
      >
        <span
          class="menu-ellipsis"
          :class="{ 'menu-ellipsis-data': oneMenuSelect }"
          v-if="selectMenu.length"
        >...</span>
        <a-select
          ref="select"
          class="a-select"
          v-model:value="oneMenuSelect"
          style="width: 200px"
        >
          <a-select-option
            @click="oneMenuSelectClick(index + realMenu.length)"
            v-for="(item, index) in selectMenu"
            :value="item.id"
          >{{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <!-- 超过8个一级菜单下拉框展示end -->
    </div>
    <div class="topNav-right">
      <div class="inform-center">
        <a-popover
          :title="null"
          v-model="showInform"
          trigger="click"
          @visibleChange="visibleChange"
          placement="bottomRight"
        >
          <template slot="content">
            <inform-center @goDetail="openInform" />
          </template>
          <a-badge
            :count="msgCenterCount"
            :overflow-count="99"
            :offset="[0, 0]"
          >
            <a-icon type="bell" />
          </a-badge>
        </a-popover>
      </div>
      <!-- 用户名 -->
      <div class="user-info">
        <div class="user-avatar">
          <img src="@/assets/images/layout/avatar.svg" />
        </div>
        <a-dropdown
          :trigger="['click']"
          @visibleChange="visibleChange"
          overlayClassName="user-name-dropdown"
        >
          <span
            class="user-name"
            @click="(e) => e.preventDefault()"
          >
            <a-tooltip
              placement="top"
              overlayClassName="user-name-tooltip"
              :getPopupContainer="
                (triggerNode) => {
                  return triggerNode.parentNode || document.body;
                }
              "
            >
              <template slot="title">
                <span>{{ userInfo.name }}</span>
              </template>
              <span class="name" @click="isIdentifyList()">{{ userInfo.name }}</span>
            </a-tooltip>

            <!-- <i class="arrow-bottom"></i> -->
          </span>
          <a-menu slot="overlay">
            <a-menu-item
              v-for="item in operateOptions"
              :key="item.value"
              @click="hanleDropDown(item.value)"
              :class="{ 'menu-item-logout': item.value == 'logout' }"
            >
              <span>{{ item.label }}</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>

    <personal-info
      v-if="personalInfoShow"
      @openModal="openPersonalInfo"
    ></personal-info>
    <modify-password
      v-if="modifyPwdShow"
      @openModal="openModifyPwd"
    ></modify-password>
    <SafeSettingDialog
      v-if="opSafeSetShow"
      @hideSafeSetting="hideSafeSetting"
      @submitSafeSetting="submitSafeSetting"
      :openSafeSetting="openSafeSetting"
    />
    <AccountSetting
      v-if="accountSetttingShow"
      :openSafeSetting="openSafeSetting"
      :openProjectSelection="openProjectSelection"
      @handleCloseModal="handleCloseModal"
      @hideSafeSetting="hideSafeSetting"
      @submitSafeSetting="submitSafeSetting"
      @submitProjectSetting="submitProjectSetting"
    />
  </div>
</template>

<script>
// import { menu } from '@/config'
import { mapState } from "vuex";
import { Modal } from "ant-design-vue";

import PersonalInfo from "@/views/personal-center";
import ModifyPassword from "@/views/modify-password";
import EnterpriseSelect from "@/views/entprise-select/IndexThree.vue";
import InformCenter from "@/views/inform-center/index.vue";
import { messageAccountAPi } from "@/api/infromCenter";
import { store, event } from "@ice/stark-data";

// 个性化配置 - 动态换肤
import cssVars from "css-vars-ponyfill"; // css var 的垫片
const color = require("@/styles/theme/variable.js")["primary-color"];
import { generateProjectName } from "@/constant/projectNameConfig.js";
import {
  getStore,
  setStore,
  setSession,
} from "@/utils/storage";
import { getEnterpriseConfigDetail } from "@/api/projectTree";
import {
  queryPersonalSafeSetting,
  confPersonalSafeSetting,
  queryPersonalProjectSelection,
  confPersonalProjectSelection,
  getIdentifyInfo
} from "@/api/personal.js";

import SafeSettingDialog from '@/views/safe-setting/index.vue'
import AccountSetting from '@/views/account-setting/Index.vue'
const restOperateOptions = process.env.VUE_APP_ENV === "xmtyg"
  ? [
    {
      label: "返回工作门户",
      value: "logout",
    }
  ]
  : [
    {
      label: "修改密码",
      value: "modifyPwd",
    },
    {
      label: "退出登录",
      value: "logout",
    }
  ]
const operateOptions = [
  {
    label: "账户设置",
    value: "accountSetting",
  }
  // {
  //   label: "个人中心",
  //   value: "personal",
  // },
  // {
  //   label: "安全设置",
  //   value: "safeSetting",
  // },
].concat(restOperateOptions)

export default {
  name: "TopNav",
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    allMenuMark: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    PersonalInfo,
    ModifyPassword,
    InformCenter,
    EnterpriseSelect,
    SafeSettingDialog,
    AccountSetting
  },
  data () {
    return {
      // menu,
      projectName: "",
      logoUrl: require("../../assets/images/common/defaultLogo.png"),
      currentNav: [],
      staffInfo: {},
      operateOptions,

      personalInfoShow: false,
      modifyPwdShow: false,
      showVisible: false,
      showInform: false,
      stompClient: null,
      enterPriseName: "",
      mTempMenuUrl: [],
      oneMenuSelect: "",
      screenWidth: null,
      realMenu: [],
      selectMenu: [],
      opSafeSetShow: false,
      openSafeSetting: false, //默认不开启安全设置
      openProjectSelection: false, //默认不开启项目选择
      isZH: false,
      accountSetttingShow: false
    };
  },
  computed: {
    ...mapState(["userInfo", "msgCenterCount", "ents", "mLogoUrl", "curWidth"]),
  },
  mounted () {
    this.screenWidth = document.body.clientWidth;
    const env = process.env.VUE_APP_ENV || process.env.VUE_APP_FORMATS;
    if (env == "zh") {
      this.isZH = true;
    }
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.getMenuLen(this.screenWidth);
      })();
    };
  },
  watch: {
    screenWidth (n, o) {
      this.$store.commit("SET_FOLDING", n < 1440 ? true : false);
      this.getMenuLen(n);
    },
    $route (to, from) {
      const { path } = this.$route;
      if (
        path.startsWith("/main/workBench") ||
        path === "/main/showAllList" ||
        path === "/main/informCenter"
      ) {
        this.$store.commit("SET_SUBMENU", []);
        this.currentNav = ["home"];
        return;
      }

      const { menu } = this;
      // const { path } = to
      for (let index = 0; index < menu.length; index++) {
        const element = menu[index];
        if (this.hasRoute(element, path)) {
          this.currentNav = [element.code];

          this.$store.commit("SET_SUBMENU", element.children);
        }
      }
    },
    menu (data) {
      this.getMenuLen(this.screenWidth);
      const { path } = this.$route;
      this.mTempMenuUrl = [];
      // 兼容首页为数据看板url
      if (
        path.startsWith("/main/workBench") ||
        path === "/main/showAllList" ||
        path === "/main/informCenter"
      ) {
        this.currentNav = ["home"];
        return;
      }
      // const { menu } = this
      const menu = data;

      // const { path } = this.$route
      for (let index = 0; index < menu.length; index++) {
        const element = menu[index];
        if (this.hasRoute(element, path)) {
          this.currentNav = [element.code];
          this.$store.commit("SET_SUBMENU", element.children);
        }
      }
      for (let index = 0; index < menu.length; index++) {
        const element = menu[index];
        this.mTempMenuUrl.push(element.menuUrl);
        this.isCurPath(element.children);
      }
      if (this.mTempMenuUrl.length) {
        const hsSome = this.mTempMenuUrl.some((o) => {
          return o == path || o.split('?')[0] == path
        })
        if (!hsSome) {
          this.$store.commit("SET_ACTIVEMENU", "home");
          this.$store.commit("SET_SUBMENU", []);
          this.currentNav = ["home"];
          window.history.pushState({}, "", "/main/workBench");
          // location.reload();
        }
      }
    },
  },
  created () {
    window.addEventListener("keydown", this.keyDown);
    this.getInformAccount();
    this.isIdentifyList()
  },
  methods: {
    isCurPath (children) {
      children.forEach((element) => {
        this.mTempMenuUrl.push(element.menuUrl);
        this.isCurPath(element.children);
      });
    },
    isIdentifyList () {
      getIdentifyInfo().then((res) => {
        if(res.code === 1000 && res.result.length) {
          console.log(this.operateOptions,'operateOptions')
          this.operateOptions = [
            {
              label: "账户设置",
              value: "accountSetting",
            },
            {
              label: "修改密码",
              value: "modifyPwd",
            },
            {
              label: "切换身份",
              value: "changIdentify"
            },
            {
              label: "退出登录",
              value: "logout",
            }
          ]
        } else {
          this.operateOptions = [
            {
              label: "账户设置",
              value: "accountSetting",
            },
            {
              label: "修改密码",
              value: "modifyPwd",
            },
            {
              label: "退出登录",
              value: "logout",
            }
          ]
        }
      })
    }, 
    getMenuLen (n) {
      if (!this.menu) {
        return;
      }
      // this.menu.push(this.menu)
      if (n <= 1366 && n >= 955) {
        // this.oneMenuSelect = ''
        (this.realMenu =
          this.menu.length > 5 ? this.menu.slice(0, 5) : this.menu),
          (this.selectMenu =
            this.menu.length > 5 ? this.menu.slice(5, this.menu.length) : []);
      } else if (n <= 1536 && n >= 1366) {
        // this.oneMenuSelect = ''
        (this.realMenu =
          this.menu.length > 9 ? this.menu.slice(0, 9) : this.menu),
          (this.selectMenu =
            this.menu.length > 9 ? this.menu.slice(9, this.menu.length) : []);
      } else if (n <= 1920 && n >= 1536) {
        (this.realMenu =
          this.menu.length > 10 ? this.menu.slice(0, 10) : this.menu),
          (this.selectMenu =
            this.menu.length > 10 ? this.menu.slice(10, this.menu.length) : []);
      } else if (n <= 955 && n >= 830) {
        // this.oneMenuSelect = ''
        (this.realMenu =
          this.menu.length > 3 ? this.menu.slice(0, 3) : this.menu),
          (this.selectMenu =
            this.menu.length > 3 ? this.menu.slice(3, this.menu.length) : []);
      } else if (n <= 688 && n >= 500) {
        // this.oneMenuSelect = ''
        (this.realMenu =
          this.menu.length > 1 ? this.menu.slice(0, 1) : this.menu),
          (this.selectMenu =
            this.menu.length > 1 ? this.menu.slice(1, this.menu.length) : []);
      } else if (n <= 2133 && n >= 1920) {
        (this.realMenu =
          this.menu.length > 12 ? this.menu.slice(0, 12) : this.menu),
          (this.selectMenu =
            this.menu.length > 12 ? this.menu.slice(12, this.menu.length) : []);
      } else if (n > 2133) {
        (this.realMenu = this.menu), (this.selectMenu = []);
        // this.oneMenuSelect = ''
        // this.realMenu = this.menu.length > 9 ?  this.menu.slice(0,9) : this.menu,
        // this.selectMenu = this.menu.length > 9 ? this.menu.slice(9,this.menu.length) : []
      }
    },
    changeEntInfo (entInfo) {
      this.enterPriseName = entInfo.name;
      this.$emit("reloadEntMenu", entInfo.id);
      this.$nextTick(() => {
        this.getEnterpriseConfigDetails(entInfo);
      });
    },
    async getInformAccount () {
      const { code, result } = await messageAccountAPi({
        categoryCode: ["alarm", "system", "biz_notice"],
        isRead: false,
        channels: ["WEBSOCKET"],
      });
      if (code === 1000) {
        this.$store.dispatch("messageCenterCount", result.total);
      } else {
        this.$message.warning("消息数量获取失败！");
      }
    },
    openInform () {
      this.showInform = !this.showInform;
    },
    keyDown (key) {
      if (key.code === "Escape" && this.showInform === true) {
        this.showInform = false;
      }
    },
    getFirstUrl (menuArr) {
      // 去掉面包屑默认值
      event.emit("currentBread", "");
      if (menuArr.length === 0) return "";
      let menu = menuArr[0];
      if (menu?.extendz) {
        setStore("hwUrl", menu?.extendz);
      }
      if (menu?.menuUrl) {
        this.$store.commit("SAVE_CURRENTPATH", menu?.menuUrl);
        setSession("currentPath", menu?.menuUrl);
        return menu.menuUrl;
      }
      if (menu.children && menu.children.length) {
        return this.getFirstUrl(menu.children);
      }
    },

    closeInform () {
      this.showInform = false;
    },
    oneMenuSelectClick (index) {
      let selectMenuCode = this.menu[index].code;
      this.handleClick("", selectMenuCode);
    },
    handleClick ({ key }, code) {
      if (key) {
        this.oneMenuSelect = "";
      }

      let realKey = key ? key : code;
      sessionStorage.removeItem("subCode");
      const itemMenu = this.menu.filter((o) => {
        return o.code == realKey;
      })?.[0];
      if (itemMenu?.type) {
        this.$store.commit("MENU_ENT_TYPE", itemMenu?.type == 3 ? true : false);
      }
      if (realKey === "home") {
        // this.showVisible = true
        // 解决在看板角色首页再次点击首页菜单时,无法正常卸载首页的孙子应用(看板),页面报错,导致其他子应用无法正常加载
        if (window.location?.pathname?.indexOf("/main/workBench") > -1) return;
        window.history.pushState({}, "", "/main/workBench");
        this.$store.commit("SET_SUBMENU", []);
        this.$store.commit("SET_ACTIVEMENU", "home");
        return;
      }
      if (key === "VehicleScheduling" || key === "ConsumerSafetyIntegration") {
        let itemMenu = this.menu.filter((o) => {
          return o.code == realKey;
        })?.[0];
        // this.showVisible = true
        window.history.pushState({}, "", itemMenu.menuUrl);
        this.$store.commit("SET_SUBMENU", []);
        this.$store.commit("SET_ACTIVEMENU", "");
        return;
      }
      const element = this.menu.find((i) => i.code === realKey);
      // this.$store.commit('SET_ACTIVEMENU', element.code)

      this.$store.commit("SET_SUBMENU", element.children || [])

      const url = element.children.length > 0 ? this.getFirstUrl(element.children) : element.menuUrl;
      if (url) {
        window.history.pushState({}, "", url);
        this.$store.commit("SET_SUBMENU", element.children || []);
        if (realKey === 'largeScreen') {
          const data = {
            appId: getStore('appId'),
            industryId: getStore('industryId'),
            accessToken: getStore('privateAccessToken'),
          }
          const href = 'http://172.17.1.177:19012/FrontXqLargeScreen/#/dashboard-list'
          const childWindow = window.open(href, '_blank')
          setTimeout(() => {
            childWindow.postMessage(data, href)
          }, 1000)
        }
        const mI = this.getFirstUrl(element.children);
        if (mI.menuUrl) {
          // if (mI?.type) {
          //   this.$store.commit('MENU_ENT_TYPE', mI?.type == 3 ? true : false)
          // }
          window.history.pushState({}, "", mI.menuUrl);
        }
      }
    },

    hasRoute (menu, path) {
      if (menu?.menuUrl && menu?.menuUrl === path) {
        if (menu?.type) {
          this.$store.commit("MENU_ENT_TYPE", menu?.type == 3 ? true : false);
        }
        this.$store.commit("SET_ACTIVEMENU", menu.code);
        return true;
      }

      for (let i = 0; i < menu.children.length; i++) {
        const element = menu.children[i];
        if (element?.menuUrl && element?.menuUrl === path) {
          if (element.menuType != 0) {
            if (element?.type) {
              this.$store.commit(
                "MENU_ENT_TYPE",
                element?.type == 3 ? true : false
              );
            }
            this.$store.commit("SET_ACTIVEMENU", element.code);
          }
          return true;
        } else {
          if (this.hasRoute(element, path)) return true;
        }
      }
    },
    // 退出登录
    handleLogout () {
      const _this = this;

      if (process.env.VUE_APP_ENV === "xmtyg") {
        location.replace('http://10.20.206.23/back/door/index.html#/home')
      } else {
        event.emit("hideMediaPlugin");
        Modal.confirm({
          content: "确认退出登录吗？",
          closable: true,
          okText: "确认",
          cancelText: "取消",
          class: "logout-dailog",
          onOk () {
            _this.$store.dispatch("logout", {
              outCode: 3,
            });
          },
          onCancel () {
            event.emit("showMediaPlugin");
          },
        });
      }
    },
    visibleChange (visible) {
      if (visible) {
        event.emit("handleShowUserAvatarMenu");
      } else {
        event.emit("handleHideUserAvatarMenu");
      }
    },

    async fetchPersonalSafeSetting () {
      const uInfo = JSON.parse(getStore('userInfo'))
      const data = {
        loginName: uInfo.loginName
      }
      try {
        const { code, result, message } = await queryPersonalSafeSetting(data)
        if (code === 1000) {
          this.openSafeSetting = result
        } else {
          this.$message.warning(message)
        }
      } catch (error) {
        this.$message.warning('服务器异常，请重试')
      }
    },
    async fetchPersonalProjectSelection () {
      const uInfo = JSON.parse(getStore('userInfo'))
      const data = {
        loginName: uInfo.loginName
      }
      try {
        const { code, result, message } = await queryPersonalProjectSelection(data)
        if (code === 1000) {
          this.openProjectSelection = result
        } else {
          this.$message.warning(message)
        }
      } catch (error) {
        this.$message.warning('服务器异常，请重试')
      }
    },
    hanleDropDown (value) {
      switch (value) {
        case "personal":
          event.emit("hideMediaPlugin");
          this.personalInfoShow = true;
          return;
        case "modifyPwd":
          event.emit("hideMediaPlugin");
          this.modifyPwdShow = true;
          return;
        case "logout":
          this.handleLogout();
          return;
        case "accountSetting": //账户设置
          this.accountSetttingShow = true;
          this.fetchPersonalSafeSetting()
          this.fetchPersonalProjectSelection()
          event.emit("hideMediaPlugin");
          return;
        case "safeSetting": //安全设置
          this.opSafeSetShow = true;
          this.fetchPersonalSafeSetting()
          this.opSafeSetShow = true
          event.emit("hideMediaPlugin");
          return;
        case "changIdentify": 
          console.log('切换身份', window.location.href)
          // 如果点击了切换身份的按钮，跳转到身份的页面
          // window.location.push(`${window.location.origin}/auth/role-choice`)
          window.location.href = `${window.location.origin}/auth/role-choice`
          return
        default:
          return false;
      }
    },
    openPersonalInfo (boolean) {
      if (typeof boolean === "boolean") {
        this.personalInfoShow = boolean;
        if (!boolean) {
          event.emit("showMediaPlugin");
        }
      }
    },
    openModifyPwd (boolean) {
      if (typeof boolean === "boolean") {
        this.modifyPwdShow = boolean;
        if (!boolean) {
          event.emit("showMediaPlugin");
        }
      }
    },
    hideSafeSetting (isHide) {
      if (typeof isHide === "boolean") {
        this.accountSetttingShow = isHide;
        if (!isHide) {
          event.emit("showMediaPlugin");
        }
      }
    },
    closeEntSelect (bool) {
      this.showVisible = bool;
      this.$actions.setGlobalState({ openPeojectModel: "close" });
    },
    getEnterpriseConfigDetails (data) {
      const params = {
        enterpriseId: data.id,
        industryId: getStore("industryId"),
      };
      getEnterpriseConfigDetail(params)
        .then((res) => {
          let markedMenu = [];
          if (res.code === 1000) {
            setTimeout(() => {
              document.title = res?.result?.name || generateProjectName();
            }, 1000);
            this.logoUrl =
              res?.result?.logoUrl ||
              require("@/assets/images/common/defaultLogo.png");
            if (res?.result?.openStatus == 1) {
              //加水印
              this.$nextTick(() => {
                setTimeout(() => {
                  if (this.$parent.allMenuMark.length > 0) {
                    this.$parent.allMenuMark.forEach((i) => {
                      if (res?.result?.permissionId) {
                        res?.result?.permissionId.split(",").forEach((j) => {
                          if (i.id == j) {
                            markedMenu.push(i);
                          }
                        });
                      }
                    });
                    store.set("allMarkMenu", markedMenu);
                  } else {
                    store.set("allMarkMenu", undefined);
                  }
                }, 1000);
              });
              store.set("defaultMainColor", res?.result?.themeColor || color);
              this.changeCustomTheme(res?.result?.themeColor || color);
            } else {
              store.set("allMarkMenu", undefined);
              document.title = generateProjectName();
              store.set("defaultMainColor", res?.result?.themeColor || color);
              this.changeCustomTheme(res?.result?.themeColor || color);
              // store.set("defaultMainColor", color);
              // this.changeCustomTheme(color);
            }
            const link =
              document.querySelector('link[rel*="icon"]') ||
              document.createElement("link");
            link.type = "image/x-icon";
            link.rel = "shortcut icon";
            link.href = res.result.icoUrl;
            document.getElementsByTagName("head")[0].appendChild(link);
            if (this.isIE()) {
              setTimeout(() => {
                this.changeCustomTheme(res.result?.themeColor || color);
                cssVars({
                  watch: true,
                });
              }, 0);
            } else {
              store.set("defaultMainColor", res?.result?.themeColor || color);
              this.changeCustomTheme(res?.result?.themeColor || color);
            }
          } else {
            document.title = generateProjectName();
            store.set("defaultMainColor", color);
            this.changeCustomTheme(color);
          }
        })
        .catch(() => {
          document.title = generateProjectName();
          store.set("defaultMainColor", color);
          this.changeCustomTheme(color);
        });
    },

    openProjectSelect () {
      if (this.ents.length <= 1) {
        return;
      }
      this.showVisible = true;
      this.$actions.setGlobalState({ openPeojectModel: "open" });
    },
    isIE () {
      if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
      else return false;
    },
    olorRgb (color) {
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var sColor = color.toLowerCase();
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        //处理六位的颜色值
        var sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return "rgba(" + sColorChange.join(",") + ", .1)";
      } else {
        return sColor;
      }
    },
    changeCustomTheme (defaultMainColor) {
      let docEle = document.documentElement;
      const auTheme = {
        "--theme-color": defaultMainColor || color,
        "--theme-alpha-color":
          this.olorRgb(defaultMainColor) || this.olorRgb(color),
      };
      // 批量覆盖样式
      for (const key in auTheme) {
        if (auTheme.hasOwnProperty(key)) {
          const value = auTheme[key];
          // 关键
          docEle.style.setProperty(key, value);
        }
      }
      docEle = null;
    },
    async submitSafeSetting (v) {
      const data = {
        dualAuth: v
      }
      try {
        const { code, message } = await confPersonalSafeSetting(data)
        // 配置成功
        if (code === 1000) {
          this.openSafeSetting = v
          this.$message.success('设置成功')
          this.hideSafeSetting(false)
        } else {
          this.$message.warning(message)
        }
      } catch (error) {
        this.$message.warning('服务器异常，请重试')
      }
    },
    async submitProjectSetting (v) {
      // 设置项目配置操作
      const data = {
        switchProject: v
      }
      this.openProjectSelection = v
      try {
        const { code, message } = await confPersonalProjectSelection(data)
        // 配置成功
        if (code === 1000) {
          this.$message.success('设置成功')
          this.hideSafeSetting(false)
        } else {
          this.openProjectSelection = !v
          this.$message.warning(message)
        }
      } catch (error) {
        this.openProjectSelection = !v
        this.$message.warning('服务器异常，请重试')
      }
    },
    handleCloseModal () {
      this.accountSetttingShow = false
    }
  },
};
</script>
<style lang="less">
.menu-select {
  line-height: 56px;
  position: relative;
  .a-select {
    // 新修改start
    position: static;
    opacity: 0;
    // 新修改
  }
  .business-select-selection--single {
    border: none;
    background-color: var(--theme-color) !important;
    height: 56px;
    // 新修改start
    position: static;
    // 新修改
  }
  .business-select-selection-selected-value {
    color: #fff;
  }
  .business-select-enabled {
    // height: 56px;
    cursor: pointer;
  }
  .menu-ellipsis {
    position: absolute;
    left: 15px;
    height: 10px;
    cursor: pointer;
    color: #fff;
    // 新加
    bottom: 51px;
    // 新加
    // z-index: 0!important;
    font-size: 27px;
  }
  // 新加end
  // .menu-ellipsis-data {
  //   margin-left: 101px;
  // }
  .menu-ellipsis-data::before {
    content: '';
    border-top-style: solid;
    border-top-color: #fff !important;
    width: 24px;
    display: inline-block;
    position: absolute;
    bottom: -51px;
  }
  // 新加end
  .business-select-arrow .business-select-arrow-icon svg {
    display: none;
  }
}
</style>
<style lang="less" scoped>
.topNav {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  background: @top-bg-color;
  z-index: 10;
  /deep/ li.list-item.house-menu-item.house-menu-item-selected {
    color: #fff;
    border-bottom: 2px solid #fff;
    font-weight: 500;
  }
  .house-menu-item:hover {
    color: #fff;
    border-bottom: 2px solid #fff;
  }
  li.list-item.house-menu-item.house-menu-item-selected:hover {
    color: #fff;
  }

  // 云屏管理平台和智能家居应用平台 start
  /deep/ li.list-item.cloudPanel-menu-item.cloudPanel-menu-item-selected,
  /deep/ li.list-item.smartHome-menu-item.smartHome-menu-item-selected {
    color: #fff;
    border-bottom: 2px solid #fff;
    font-weight: 500;
  }
  .cloudPanel-menu-item:hover,
  .smartHome-menu-item:hover {
    color: #fff;
    border-bottom: 2px solid #fff;
  }
  li.list-item.cloudPanel-menu-item.cloudPanel-menu-item-selected:hover,
  li.list-item.smartHome-menu-item.smartHome-menu-item-selected:hover {
    color: #fff;
  }
  // 云屏管理平台和智能家居应用平台 end

  .topNav-logo111 {
    display: flex;
    align-items: center;
    // width: 240px;
    // max-width: 340px;
    height: 100%;
    padding-left: 16px;
    flex-shrink: 0;
    img {
      width: auto;
      height: auto;
      max-width: 39px;
      max-height: 39px;
    }

    // div {
    //   // position: relative;
    //   display: flex;
    //   align-items: center;
    //   height: 24px;
    //   padding-left: 10px;
    //   color: @primary-color;

    //   /* 导航栏的项目选择器的向下的箭头 */

    //   span {
    //     width: 127px;
    //     color: #fff;
    //     white-space: nowrap;
    //     font-size: 16px;
    //   }
    // }
    // .trail-icon {
    //   &::after {
    //     content: '';
    //     position: absolute;
    //     right: -15px;
    //     margin-left: -7px;
    //     z-index: 9;
    //     width: 0;
    //     height: 0;
    //     border-left: 6px solid transparent;
    //     border-right: 6px solid transparent;
    //     border-top: 7px solid #fff;
    //   }
    // }
    .ent-name-info {
      padding-left: 10px;
      span {
        width: 127px;
        color: #fff;
        white-space: nowrap;
        font-size: 16px;
        display: inline-block;
      }
    }
  }
  .topNav-logo-hover {
    cursor: pointer;
  }

  .topNav-list {
    display: inline-flex;
    justify-content: flex-start;
    height: 100%;
    overflow: hidden;
    flex: 1;
    // width: calc(100vh - 440px);
    // max-width: calc(100vh - 540px);
    // overflow-x: auto;
    overflow-y: hidden;
    .list-menu {
      height: 56px;
      line-height: 56px;
      border: none;
      font-size: 16px;
      color: #fff;
      color: rgba(255, 255, 255, 0.75);
      background: @top-bg-color;

      .list-item {
        margin-right: 80px;
        padding: 0;
        height: 55px;
        vertical-align: top;
      }
    }
  }

  .topNav-right {
    width: 150px;
    height: 100%;
    padding-right: 40px;
    line-height: 56px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .inform-center {
    height: 100%;
    line-height: 60px;
    margin-right: 34px;
    color: #fff;
    background-color: var(--theme-color) !important;
    z-index: 1;
    .house-badge {
      padding-right: 9px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .user-info {
    height: 100%;
    line-height: 56px;
    display: flex;
    color: #fff;
    align-items: center;
    .user-avatar {
      display: flex;
      align-items: center;
      margin-right: 15px;
      img {
        width: 32px;
        height: 32px;
      }
    }
    .user-name {
      display: flex;
      align-items: center;
      color: #fff;
      cursor: pointer;

      .name {
        display: inline-block;
        margin-right: 11px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100px;
      }
      .arrow-bottom {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-top: 2px solid #000;
        border-right: 2px solid #000;
        transform: rotate(135deg);
      }
    }
  }
}
.env-zh {
  background: #fff !important;
  border-bottom: 1px solid #f0f0f0;
  z-index: 10;
  .topNav-list .list-item:hover {
    color: var(--theme-color) !important;
    border-bottom: 2px solid var(--theme-color) !important;
    font-weight: 500;
  }
  .topNav-list > ul > [class*='-menu-item-selected'] {
    color: var(--theme-color) !important;
    border-bottom: 2px solid var(--theme-color) !important;
    font-weight: 500;
  }
  .menu-select .menu-ellipsis {
    color: #262626 !important;
  }
  .topNav-list {
    .list-menu {
      color: #8c8c8c;
      //color: rgba(255, 255, 255, 0.75);
      background-color: #fff !important;
    }
  }
  .inform-center {
    color: #262626;
    background-color: #fff !important;
  }
  .user-info {
    height: 100%;
    line-height: 56px;
    display: flex;
    color: #fff;
    align-items: center;
    .user-name {
      display: flex;
      align-items: center;
      color: #262626;
      cursor: pointer;

      .name {
        display: inline-block;
        margin-right: 11px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100px;
      }
      .arrow-bottom {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-top: 2px solid #000;
        border-right: 2px solid #000;
        transform: rotate(135deg);
      }
    }
  }
}
.house-dropdown-menu {
  width: 200px;
  padding: 12px 0 6px;
  .house-dropdown-menu-item {
    padding: 0 16px;
    span {
      display: inline-block;
      height: 50px;
      line-height: 50px;
    }
    &:hover {
      background: @background-color-base;
      span {
        color: @primary-color;
      }
    }
  }
}
</style>
<style lang="less">
.house-popover-placement-bottom,
.house-popover-placement-bottomLeft,
.house-popover-placement-bottomRight {
  z-index: 10000 !important;
}
</style>
